import { render, staticRenderFns } from "./UlasKontrak.vue?vue&type=template&id=2372d2e8&scoped=true&"
import script from "./UlasKontrak.vue?vue&type=script&lang=js&"
export * from "./UlasKontrak.vue?vue&type=script&lang=js&"
import style0 from "./UlasKontrak.vue?vue&type=style&index=0&id=2372d2e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2372d2e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Project/Gitpanda/Agroforestcape/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VCard,VCardActions,VCardText,VContainer,VContent,VFlex,VLayout})
